/* eslint no-unused-expressions: 0 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import TooltipIcon from './TooltipIcon';

export const Tooltip = props => {
  const { className, display, id, position, hoverText, tooltipText, multiline } = props;
  const underline = display === 'underline' ? 'pxl-tooltip-underline' : '';
  return (
    <Fragment>
      <span className={`pxl-tooltip ${underline} ${className}`} data-tip={hoverText} data-for={id}>
        {tooltipText}
        <TooltipIcon display={display} />
      </span>
      <ReactTooltip id={id} place={position} multiline={multiline} />
    </Fragment>
  );
};

Tooltip.propTypes = {
  className: PropTypes.string,
  display: PropTypes.oneOf(['underline', 'icon']),
  hoverText: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'top', 'bottom', 'right']),
  tooltipText: PropTypes.string.isRequired
};

Tooltip.defaultProps = {
  className: '',
  display: 'icon',
  multiline: false,
  position: 'top'
};

export default Tooltip;
